import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { MaterialApi } from '../material-api';
import type { IQueryRoot } from '@eureka/services/src/types/query'
import type { ISuggestItem, ISuggestItemServer } from '../../types';

@injectable()
export class MaterialApiImpl extends PsHttpService implements MaterialApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    suggestPlaybook(keyword: string, fields = 'AUTOCOMPLETE', playbook = 'MaterialSearch') {
        return this.post<PatSnapCommonResponseData<ISuggestItem[]>>({
            url: '/smart/suggest',
            data: {
                fields,
                keyword,
                playbook,
            },
        }).then(res => {
            return res.data || []
        })
    }

    suggestField(keyword: string, field: string, n = 10) {
        return this.post<PatSnapCommonResponseData<ISuggestItemServer[]>>({
            url: `/smart/suggest/${field}`,
            data: {
                keyword,
                n,
            },
        }).then(res => {
            return res.data || []
        })
    }

    /**
     * 获取推荐词
     */
    recommends(): Promise<{[key in string] :IQueryRoot[]}> {
        return this.get({
            url: '/onboard/material/query',
        }).then(res => {
            return res.data || []
        })
    }
}
